import { fetchData, API_TYPE, IResponse } from '@umu/umu-fetch';

const Api = {
    /**
     * @description 企业版水印配置相关接口
     * @interface http://api.umucdn.cn/project/126/interface/api/5690
     */
    GET_CUSTOMIZE_CONFIG: {
        url: `/uapi/v1/enterprise/get-customize-config`,
        type: API_TYPE.GET,
    },
};

/**
 * pdf 渲染方式
 */
export enum PDF_RENDER_TYPE {
    CANVAS,
    SVG,
}

export interface IResponseWatermarkConfig {
    text: string;
    style: {
        color: string;
        rotate: string;
        font: string;
        trasparency: string;
        size: string;
        offsetX: string;
        offsetY: string;
        malOffset: string;
    };
}

export interface IGetCustomizeConfigResponse {
    [key: string]: IResponseWatermarkConfig;
}

const WATERMARK_CONFIG_NAMES = {
    config_names: 'watermark,fullsite_watermark,fullsite_dark_watermark',
};

export function getCustomizeConfig() {
    return fetchData(Api.GET_CUSTOMIZE_CONFIG, WATERMARK_CONFIG_NAMES).then(
        (res: IResponse<IGetCustomizeConfigResponse>) => {
            return res;
        },
    );
}

/**
 * 使用SVG渲染
 */
export const renderSvg = (
    pdfjsLib: any,
    page: any,
    viewport: any,
    container: any,
    isMustUseSvg: boolean,
    cb: (isRendered: boolean) => void,
) => {
    if (!container) {
        return;
    }

    /**
     * 解决https://statics-umu-test.umucdn.cn/resource/T/ab/yzlno/1228256504.pdf这个文件在svg下，
     * 渲染不完整，但是又不报错的情况。原理：在svg渲染时，劫持其中的log信息，
     * 检查”Warning: Unimplemented graphic state operator BM“，当发现有这个log时，触发pdf使用canvas渲染
     */
    const windowConsoleLogFn = console.log;
    console.log = function (...args) {
        windowConsoleLogFn(...args);
        if (arguments?.[0]?.indexOf?.('Unimplemented graphic state operator BM') > -1) {
            if (!isMustUseSvg) {
                throw new Error(arguments[0]);
            } else {
                console.error(arguments[0]);
            }
        }
    };

    return page
        .getOperatorList()
        .then((opList: any) => {
            const svgGfx = new pdfjsLib.SVGGraphics(page.commonObjs, page.objs);
            return svgGfx.getSVG(opList, viewport);
        })
        .then((svg: any) => {
            svg.style.width = `calc(var(--scale-factor) * ${Math.floor(viewport.width)}px)`;
            svg.style.height = `calc(var(--scale-factor) * ${Math.floor(viewport.height)}px)`;
            container.innerHTML = '';
            container.appendChild(svg);
            console.log = windowConsoleLogFn;
            cb(true);
        })
        .catch((error: any) => {
            console.log = windowConsoleLogFn;
            cb(false);
            console.error(error.message);
        });
};
